import * as React from 'react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient } from '@tanstack/react-query';
import { PageNotFound } from '@/ui/templates/PageNotFound';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
  notFoundComponent: PageNotFound,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <ReactQueryDevtools position="top" />
      {/* <TanStackRouterDevtools position="bottom-left" /> */}
    </>
  );
}
